import type { Technique } from '../types';
import { GLYPH_PARTICLES_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type GlyphParticlesState } from './render';

export const glyphParticles: Technique<GlyphParticlesState> = {
  id: 'glyph-particles',
  name: 'Buchstaben-Partikel',
  category: 'field',
  description: 'Statt Punkten werden Zeichen durch das Feld getrieben.',
  params: GLYPH_PARTICLES_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
